import { gql } from '@apollo/client';

export const COMPANY_UPDATE = gql`
	mutation CompanyUpdate($id: Identifier!, $input: CompanyInput!) {
		CompanyUpdate(id: $id, input: $input) {
			company {
				id
				name
				salesTarget
				commissionPriority
				updatedAt
			}
		}
	}
`;
